import {Component} from 'preact';
import {$CONTENT_WINDOW} from '@config/selectors';
import {useLocation} from 'react-router-dom';
import {useEffect} from 'react';

export default class ScrollToTop extends Component {

    componentDidMount () {
        this.contentScroller = document.querySelector( $CONTENT_WINDOW );

        this.setScroll();
    }

    componentDidUpdate ( prevProps ) {
        if ( this.props.location !== prevProps.location ) {
            this.setScroll();
        }
    }

    setScroll () {
        window.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        if ( this.contentScroller ) {
            this.contentScroller.scrollTop = 0;
        }
    }

    render ( {children} ) {
        return <div className="scrollToTop">{children}</div>
    }
}

/**
 * This is a React Hook that will scroll to the top of the page when the route changes.
 * This must be used inside of a component that is a child of the <Router> component.
 * @returns {null}
 * @constructor
 */
export function ScrollToTopOfRoute () {
    const {pathname} = useLocation();

    useEffect( () => {
        // "document.documentElement.scrollTo" is the magic for React Router Dom v6
        document.documentElement.scrollTo( {
            top: 0,
            left: 0,
            behavior: 'instant' // Optional if you want to skip the scrolling animation
        } );
    }, [pathname] );

    return null;
}
